import { useCallback } from 'react';
import { useEditorStore } from '~/shell/Store';
import { useFormState } from '~/training/sequence/templates/items/chatBot/hooks/useFormState';
import { populateFormWithChatBotData } from '~/training/sequence/templates/items/chatBot/utils/chatBotHelpers';
import { ChatBotData } from '~/training/sequence/templates/items/chatBot/types/ChatBotTypes';

export const useChatBotModal = (
  hasCreatedBots: boolean,
  conversationBotId?: number | string
) => {
  const formState = useFormState();

  const handleOpenModal = useCallback(async () => {
    if (hasCreatedBots && conversationBotId) {
      const { apiService } = useEditorStore.getState();
      if (apiService) {
        try {
          const chatBotData: ChatBotData = await apiService.getChatBot(
            String(conversationBotId)
          );
          if (!chatBotData.error && chatBotData.template_vars) {
            formState.setFormData(populateFormWithChatBotData(chatBotData));
          }
        } catch (error) {
          console.error('Error fetching chatbot data:', error);
        }
      }
    }
    formState.openModal();
  }, [hasCreatedBots, conversationBotId, formState]);

  return {
    ...formState,
    handleOpenModal
  };
};
